const Hero = () => {
  return (
    <div className="bg-[#121212] flex items-center justify-center">
      <h2 className="text-white font-bold text-[2rem] font-Poppins text-center">
        100 Thousand Songs, ad-free
        <br />
        Over thousands podcast episodes
      </h2>
      <img src="vibrating-headphone-main.png" alt="Earphone Image" />
    </div>
  );
};

export default Hero;
